import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '23',
  height: '22',
  viewBox: '0 0 23 22'
}, [
  h('path', {
    d: 'M4.3 14.4c-.2 0-2 0-3.2-1.2-.7-.8-1.1-1.7-1.1-2.9s.5-2.4 1.5-3.2c.8-.7 1.8-1 2.9-.9C4.9 2.7 7.9 0 11.5 0c2.7 0 5.1 1.5 6.4 3.8 1.3 0 2.6.5 3.5 1.5 1 1 1.6 2.4 1.6 3.8 0 4.6-4.7 5.3-4.7 5.3-.3 0-.5-.2-.6-.4s.2-.5.4-.6c.2 0 3.9-.6 3.9-4.3 0-1.2-.5-2.3-1.3-3.1-.8-.8-1.9-1.2-3.1-1.2-.2 0-.4-.1-.5-.3-1-2.2-3.2-3.5-5.6-3.5-3.3 0-6 2.6-6.2 5.8 0 .1-.1.3-.2.4-.1.1-.2.1-.4.1-.9-.2-1.9 0-2.6.6-.7.6-1.1 1.5-1.1 2.4 0 .9.3 1.6.8 2.1 1 1 2.5.9 2.5.9.3 0 .5.2.5.5 0 .4-.2.6-.5.6z'
  }),
  h('path', {
    d: 'M7.5 22c-.3 0-.5-.2-.5-.5v-9c0-.3.2-.5.5-.5s.5.2.5.5v9c0 .3-.2.5-.5.5z'
  }),
  h('path', {
    d: 'M7.5 22c-.1 0-.3 0-.4-.1l-3-3c-.2-.2-.2-.5 0-.7s.5-.2.7 0l2.6 2.6 2.6-2.6c.2-.2.5-.2.7 0s.2.5 0 .7l-3 3c.1.1-.1.1-.2.1zM14.5 19.5c-.3 0-.5-.2-.5-.5V9c0-.3.2-.5.5-.5s.5.2.5.5v10c0 .3-.2.5-.5.5z'
  }),
  h('path', {
    d: 'M17.5 12.5c-.1 0-.3 0-.4-.1l-2.6-2.6-2.6 2.6c-.2.2-.5.2-.7 0s-.2-.5 0-.7l3-3c.2-.2.5-.2.7 0l3 3c.2.2.2.5 0 .7-.1.1-.3.1-.4.1z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/nav-api.es6.js